import { ContentContainer, Title } from 'Helpers/GlobalStyles';
import { CheckMark, Text, Line } from './Success.styles';

const Success = () => (
  <ContentContainer>
    <Title>
      Payment{' '}
      <Line>
        Successful
        <CheckMark />
      </Line>
    </Title>
    <Text>Thank you for choosing Carvana!</Text>
  </ContentContainer>
);

export default Success;
